import { mkAiConversationsStore, mkErrorChatTurn } from 'data/aiConversations/aiConversationsTypes';
import { List as ImmutableList } from 'immutable';
//
import { handleActions } from 'redux-actions';

// import { getLogger } from 'app-components/utils/core';

import * as actions from './aiConversationsActions';

// const log = getLogger('data/aiConversations/aiConversationsReducer.js');
export const AI_CONVERSATIONS_REDUCER_KEY = 'aiConversationsStore';

export const aiConversationsReducer = handleActions(
  {
    [actions.makeClearAiConversationAction]: (state) => state.merge({ history: new ImmutableList([]) }),

    [actions.makeAiPromptRequestAction]: (state) => state.merge({ isLoading: true }),

    [actions.makeAiPromptRequestSuccess]: (state, action) => {
      const { payload } = action;
      return state.merge({ isLoading: false, history: ImmutableList(payload.history) });
    },

    [actions.makeAiPromptRequestFailure]: (state, { payload: error }) => {
      return state.merge({ isLoading: false, history: state.history.push(mkErrorChatTurn(error)) });
    },
  },
  mkAiConversationsStore(),
);

export default aiConversationsReducer;
